.admin {
  display: flex;
  align-items: flex-start;
  max-width: 1600px;
  margin: 0 auto;
}

.content {
  flex: 1;
  min-width: 0;
  padding: 0 24px;
}
